export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/arrow-right-up-1855ebbc9828b788dbd17edaff6ef896.svg";